import { IState } from 'services/root-reducer';
import { Dispatch, AnyAction, Middleware } from 'redux';
import { store as appStore } from '..';

export const LOCALSTORAGE_KEY = `app-data-v2@${__P_ID__}.${__MAP_CODE__}`;

const SyncField = (storage_key: keyof IState) => (
    target: LocalStorageSync,
    propertyKey: string | symbol,
    descriptor: PropertyDescriptor
) => {
    Reflect.defineMetadata('ls_sync_middleware:sync_field', storage_key, target, propertyKey);

    let original_method = descriptor.value;
    descriptor.value = (store: typeof appStore) => (next: Dispatch<AnyAction>) => (action: AnyAction) => {
        let prev_state = store.getState();
        next(action);
        let new_state = store.getState();

        let prev_value = prev_state[storage_key];
        let new_value = new_state[storage_key];
        if (prev_value !== new_value) {
            let raw_value = localStorage.getItem(LOCALSTORAGE_KEY) || '{}';
            let parsed_value;
            try {
                parsed_value = JSON.parse(raw_value);
            } catch (e) {
                console.error('[SyncField] Ошибка парсинга из localStorage', e);
                return;
            }

            parsed_value[storage_key] = original_method(new_value, prev_value, store, action);

            localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(parsed_value));
        }
    };
};

const RestoreField = (storage_key: keyof IState) => (
    target: LocalStorageSync,
    propertyKey: string | symbol,
    descriptor: PropertyDescriptor
) => {
    Reflect.defineMetadata('ls_sync_middleware:restore_field', storage_key, target, propertyKey);

    let original_method = descriptor.value;
    descriptor.value = function() {
        let raw_value = localStorage.getItem(LOCALSTORAGE_KEY) || '{}';
        let parsed_value;
        try {
            parsed_value = JSON.parse(raw_value);
        } catch (e) {
            console.error('[RestoreField] Ошибка парсинга из localStorage', e);
            return undefined;
        }

        return original_method(parsed_value[storage_key]);
    };
};

export class LocalStorageSync {
    @SyncField('favorites')
    protected SyncFavorites(new_value: IState['favorites']) {
        return new_value;
    }

    @RestoreField('favorites')
    protected RestoreFavorites(value: any) {
        return value;
    }

    @SyncField('app')
    protected SyncToken(new_value: IState['app']) {
        let { authToken } = new_value;
        return { authToken };
    }

    @RestoreField('app')
    protected RestoreToken(value: any) {
        return value;
    }

    static getMiddlewares(): Middleware[] {
        let sync = new LocalStorageSync();
        let middlewares = [];
        let keys = Reflect.ownKeys(Reflect.getPrototypeOf(sync));
        for (let key of keys) {
            let sync_field = Reflect.getMetadata('ls_sync_middleware:sync_field', sync, key.toString());
            if (sync_field) {
                middlewares.push(sync[key]);
            }
        }
        return middlewares;
    }

    static restoreStore() {
        let store = {};
        let sync = new LocalStorageSync();
        let keys = Reflect.ownKeys(Reflect.getPrototypeOf(sync));
        for (let key of keys) {
            let restore_key = Reflect.getMetadata('ls_sync_middleware:restore_field', sync, key.toString());
            let restore_method = sync[key];
            if (restore_key) {
                let restored_value = restore_method();
                if (restored_value !== undefined) {
                    store[restore_key] = restored_value;
                }
            }
        }
        return store;
    }
}
